import React from 'react';
import { useEffect, useMemo, useState } from 'react';
import NumberCard from './NumberCard';

const DHMSTimer: React.FC<any> = ({ startDate, onTimerFinished }) => {

  const targetTime = new Date(startDate).getTime();
  const [currentTime, setCurrentTime] = useState(Date.now());
  const timeBetween = useMemo(() => targetTime - currentTime, [
    currentTime,
    targetTime
  ]);

  const days = Math.floor(timeBetween / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (timeBetween % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeBetween % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeBetween % (1000 * 60)) / 1000);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timeBetween <= 0) {
        clearInterval(interval);
        onTimerFinished();
      } else {
        setCurrentTime(Date.now());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [timeBetween, onTimerFinished]);

  return (
    <>
    <div id="countdownMockup" className="countdownHolderElements countdownHolder">
      <div className="countdownItemContainer countdownItemContainerDays">
        <NumberCard number={days} countDivClass={'countDiv countDiv0'}/>
        <div className="countdownLabel">
          <span className="countDaysLabel">Days</span>
        </div>
      </div>
      <div className="countdownItemContainer countdownItemContainerHours">
        <NumberCard number={hours} countDivClass={'countDiv countDiv1'}/>
        <div className="countdownLabel">
          <span className="countHoursLabel">Hours</span>
        </div>
      </div>
      <div className="countdownItemContainer countdownItemContainerMinutes">
        <NumberCard number={minutes} countDivClass={'countDiv countDiv2'}/>
        <div className="countdownLabel">
          <span className="countMinutesLabel">Minutes</span>
        </div>
      </div>
      <div className="countdownItemContainer countdownItemContainerSeconds">
        <NumberCard number={seconds}/>
        <div className="countdownLabel">
          <span className="countSecondsLabel">Seconds</span>
        </div>
      </div>
    </div>
    </>

)
  ;
}

export default DHMSTimer;
